import { CdrLink as b, CdrGrid as k } from "@rei/cedar";
import C from "@rei/landing-image-component";
import { palettes as v } from "@rei/landing-palettes";
import { resolveComponent as o, openBlock as a, createElementBlock as i, normalizeStyle as g, createVNode as f, withCtx as y, createTextVNode as F, toDisplayString as h, createCommentVNode as m, Fragment as T, renderList as x, createBlock as M, mergeProps as V } from "vue";
const p = (t, n) => {
  const e = t.__vccOpts || t;
  for (const [c, l] of n)
    e[c] = l;
  return e;
}, j = {
  isMediaFullWidth: !1
}, q = {
  name: "FeaturedTile",
  components: {
    ImageComponent: C,
    CdrLink: b
  },
  props: {
    body: {
      type: String,
      required: !1,
      default: ""
    },
    action: {
      type: Object,
      required: !0,
      default: () => {
      }
    },
    media: {
      type: Object,
      required: !0,
      default: () => {
      }
    },
    config: {
      type: Object,
      required: !1,
      default: () => j
    }
  },
  computed: {
    imageCssVar() {
      const {
        isMediaFullWidth: t
      } = this.config || {};
      return {
        "--media-padding": t ? "0" : "1.2rem",
        "--media-object-fit": t ? "cover" : "contain"
      };
    },
    themeCssVar() {
      const {
        palette: t
      } = this.config || {}, {
        content: n
      } = t || {};
      return v({
        content: n || "primary"
      }).cssContentPaletteVars();
    }
  }
}, O = {
  key: 0,
  class: "featured-tile__heading",
  "data-ui": "featured-tile-heading",
  role: "presentation"
}, L = ["innerHTML"];
function P(t, n, e, c, l, s) {
  var r, d;
  const u = o("image-component"), _ = o("cdr-link");
  return a(), i("div", {
    class: "featured-tile",
    "data-ui": "featured-tile",
    style: g(s.themeCssVar)
  }, [f(u, {
    class: "featured-tile__image",
    style: g(s.imageCssVar),
    media: e.media,
    "data-ui": "featured-tile-image"
  }, null, 8, ["style", "media"]), (r = e.action) != null && r.href && ((d = e.action) != null && d.text) ? (a(), i("h3", O, [f(_, {
    modifier: "standalone",
    class: "featured-tile__heading-link",
    href: e.action.href
  }, {
    default: y(() => [F(h(e.action.text), 1)]),
    _: 1
  }, 8, ["href"])])) : m("", !0), e.body ? (a(), i("div", {
    key: 1,
    class: "featured-tile__body",
    "data-ui": "featured-tile-body",
    innerHTML: e.body
  }, null, 8, L)) : m("", !0)], 4);
}
const S = /* @__PURE__ */ p(q, [["render", P]]);
const B = {
  name: "FeaturedTiles",
  components: {
    CdrGrid: k,
    FeaturedTile: S
  },
  props: {
    heading: {
      type: String,
      required: !1,
      default: ""
    },
    featuredTiles: {
      type: Array,
      required: !0,
      default: () => []
    },
    config: {
      type: Object,
      required: !1,
      default: () => {
      }
    }
  }
}, N = {
  key: 0,
  class: "featured-tiles__heading",
  "data-ui": "featured-tiles-heading"
};
function H(t, n, e, c, l, s) {
  const u = o("featured-tile"), _ = o("cdr-grid");
  return a(), i("div", null, [e.heading ? (a(), i("h2", N, h(e.heading), 1)) : m("", !0), f(_, {
    class: "featured-tiles",
    "data-ui": "featured-tiles"
  }, {
    default: y(() => [(a(!0), i(T, null, x(e.featuredTiles, (r, d) => (a(), M(u, V({
      key: d,
      ref_for: !0
    }, {
      ...r,
      config: e.config
    }), null, 16))), 128))]),
    _: 1
  })]);
}
const D = /* @__PURE__ */ p(B, [["render", H]]);
export {
  D as default
};
